(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("radio", [], factory);
	else if(typeof exports === 'object')
		exports["radio"] = factory();
	else
		root["radio"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 